export default __webpack_public_path__ + "static/media/loader-1.5be54225.gif";